export const LISTS = "/api/lists";
export const LIST = "/api/lists/:param";
